import styled from 'styled-components';
import { ColorMixin } from '../../../styles/global';

export const AboutSectionContainer = styled.div`
  .content {
    display: flex;
    flex-direction: column;
    margin-top: 90px;
  }

  .title {
    color: ${ColorMixin.secondary};
    font-size: 32px;
    margin-bottom: 10px;
  }

  p {
    color: ${ColorMixin.secondary};
    font-size: 16px;
    margin-top: 10px;
    line-height: 1.5;
  }

  @media screen and (min-width: 1025px) {
    padding: 20px 0 80px;
    margin-top: 200px;

    .content {
      display: flex;
      flex-direction: row;
    }

    .title {
      font-size: 44px;
      margin-bottom: 30px;
    }

    p {
      font-size: 22px;
    }
  }
`;

export const Left = styled.div`
  @media screen and (min-width: 1025px) {
    padding-right: 50px;
    width: 50%;
  }
`;

export const Right = styled.div`
  margin-top: 50px;
  @media screen and (min-width: 1025px) {
    margin-top: 0;
    border-left: 1px solid rgba(128, 128, 128, 0.5);
    padding-left: 50px;
    width: 50%;
  }
`;

export const SkillItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  gap: 15px;
`;

export const SkillImage = styled.img`
  width: 50px !important;
  height: 50px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 5px;
  padding: 5px;
  align-self: center;
  align-content: center;

  @media screen and (min-width: 1025px) {
    width: 70px !important;
    height: 70px !important;
  }
`;
